import { Component, EventEmitter, Input, Output } from '@angular/core';

import { Sport } from '../../models/sport';
import { NgClass } from '@angular/common';
import {
  NgbDropdown,
  NgbDropdownToggle,
  NgbDropdownMenu,
  NgbDropdownItem,
} from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-sport-selector',
  templateUrl: './sport-selector.component.html',
  styleUrls: ['./sport-selector.component.scss'],
  standalone: true,
  imports: [
    NgbDropdown,
    NgbDropdownToggle,
    NgClass,
    NgbDropdownMenu,
    NgbDropdownItem,
    TranslateModule,
  ],
})
export class SportSelectorComponent {
  @Input() sports: Sport[];
  @Input() selectedSport: Sport;
  @Input() dropDownPlacement = 'center';
  @Output() changeSport: EventEmitter<Sport>;

  constructor() {
    this.changeSport = new EventEmitter<Sport>();
  }

  onChangeSport(sport: Sport): void {
    this.changeSport.emit(sport);
  }
}
